import React, { Component } from 'react';
import Blocker from 'components/Blocker';

import { connect } from 'react-redux';

import { loadProfile } from 'actions/profile';

const mapStateToProps = ({ profile }) => ({
  profile
});

const mapDispatchToProps = {
  loadProfile
};

const asyncComponent = (isBlocked = false) => (wrapedComponent) => {
  @connect(mapStateToProps, mapDispatchToProps)
  class AsyncComponent extends React.Component {
    state = { Component: AsyncComponent.Component };

    UNSAFE_componentWillMount() {
      if (!this.state.Component) {
        if (this.props.profile.tariff) {
          const { tariff } = this.props.profile;
          if (tariff.countDay === 0 && !isBlocked) {
            this.setState({ Component: Blocker });
          } else {
            this.setState({ Component: wrapedComponent });
          }
        } else {
          this.props.loadProfile()
          .then(response => {
            const { tariff } = response.response.data.data;
            if (tariff.countDay === 0 && !isBlocked) {
              this.setState({ Component: Blocker });
            } else {
              this.setState({ Component: wrapedComponent });
            }
          });
        }
      }
    }

    UNSAFE_componentWillReceiveProps() {
      if (this.props.profile.tariff) {
        const { tariff } = this.props.profile;
        if (tariff.countDay === 0 && !isBlocked) {
          this.setState({ Component: Blocker });
        } else {
          this.setState({ Component: wrapedComponent });
        }
      }
    }

    render() {
      const { Component } = this.state;
      let isBlockedLocal = false;
      if (this.props.profile.tariff) {
        const { tariff } = this.props.profile;
        if (tariff.countDay === 0 && isBlocked) {
          isBlockedLocal = true;
        }
      }

      if (Component) {
        return <Component {...this.props} isBlocked={isBlockedLocal} />;
      }
      return null;
    }
  }
  return AsyncComponent;
};

export default asyncComponent;



// WEBPACK FOOTER //
// ./src/decorators/withValidTrafic.js